import { render } from "./LargeButton.vue?vue&type=template&id=6fc58ed7&scoped=true"
import script from "./LargeButton.vue?vue&type=script&lang=js"
export * from "./LargeButton.vue?vue&type=script&lang=js"

import "./LargeButton.vue?vue&type=style&index=0&id=6fc58ed7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc58ed7"]])

export default __exports__